export const translations = {
  en: {
    // Common
    call_now: 'Call Now',
    get_directions: 'Get Directions',
    learn_more: 'Learn More',
    contact_us: 'Contact Us',
    submit: 'Submit',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    back: 'Back',
    next: 'Next',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    
    // Navigation
    home: 'Home',
    about: 'About',
    services: 'Services',
    contact: 'Contact',
    intake: 'Intake',
    dashboard: 'Dashboard',
    faq: 'FAQ',
    service_areas: 'Service Areas',
    how_bail_works: 'How Bail Works',
    
    // Emergency Banner
    emergency_banner: '24/7 EMERGENCY BAIL SERVICE',
    
    // Home Page
    home_hero_title: 'Fast. Confidential. 24/7 Houston Bail Bonds.',
    home_hero_subtitle: 'Get your loved one released quickly with Lone Star Bonding Co. Licensed, experienced, and trusted since 1990.',
    home_tagline: '24/7 Houston Bail Bonds - Fast Release - Confidential',
    over_30_years: 'OVER 30 YEARS OF SERVICE',
    why_choose_us: 'WHY CHOOSE US',
    proven_authority: 'PROVEN AUTHORITY',
    proven_authority_desc: 'Over three decades serving Houston with integrity, speed, and unwavering commitment.',
    serving_all_houston: 'SERVING ALL OF HOUSTON',
    service_areas_desc: '24/7 bail bond coverage for all Houston area jails and communities across Harris County and beyond.',
    view_all_areas: 'VIEW ALL SERVICE AREAS',
    dont_wait: "DON'T WAIT",
    dont_wait_desc: 'Someone is standing by to help you right now. Every minute counts.',
    
    // About Page
    about_title: 'About Lone Star Bonding Co.',
    about_steve_cruz: 'Meet Steve Cruz',
    about_experience: '30+ Years Experience',
    about_license: 'Licensed - No. 74629',
    our_story: 'OUR STORY',
    our_core_values: 'OUR CORE VALUES',
    our_history: 'OUR HISTORY',
    your_trusted_bondsman: 'YOUR TRUSTED HOUSTON BAIL BONDSMAN',
    
    // Services Page
    services_title: 'Our Services',
    services_bail_bonds: 'Bail Bonds',
    services_24_7: '24/7 Availability',
    services_bilingual: 'Bilingual Support',
    bail_bond_solutions: 'BAIL BOND SOLUTIONS',
    
    // Contact Page
    contact_title: 'Contact Us',
    contact_phone: 'Phone',
    contact_address: 'Address',
    contact_hours: 'Hours',
    contact_24_7: '24/7 - Open All Day, Every Day',
    location: 'LOCATION',
    
    // FAQ
    faq_title: 'BAIL BOND FAQ',
    faq_subtitle: 'Answers to the most common questions about bail bonds in Houston and Harris County.',
    still_have_questions: 'STILL HAVE QUESTIONS?',
    still_have_questions_desc: 'Call us. We are here 24/7 to help you.',
    
    // How Bail Works
    step_by_step: 'STEP-BY-STEP GUIDE',
    how_bail_works_title: 'HOW BAIL BONDS WORK',
    how_bail_works_subtitle: 'Understanding the bail bond process does not have to be complicated. Here we explain exactly how it works from start to finish.',
    key_facts: 'KEY FACTS',
    ready_to_start: 'READY TO GET STARTED?',
    ready_to_start_desc: 'Call us now and we will walk you through every step of the process.',
    
    // Service Areas
    service_areas_title: 'SERVING EVERY HOUSTON NEIGHBORHOOD',
    service_areas_hero_desc: 'From the Harris County Jail complex downtown to the farthest reaches of the metro. 24/7 bail bond coverage for every ZIP code, every jail, every court.',
    neighborhood_coverage: 'NEIGHBORHOOD COVERAGE',
    dont_see_area: "DON'T SEE YOUR AREA?",
    dont_see_area_desc: 'We cover the ENTIRE Houston metropolitan area, Harris County, Fort Bend County, and beyond. If your loved one is in jail anywhere in southeast Texas, call. We will help.',
    
    // Intake
    intake_title: 'Bond Application Forms',
    intake_subtitle: 'One guided step-by-step questionnaire',
    intake_secure: 'Secure - Confidential - Guided',
    intake_resume: 'Resume Application',
    intake_new: 'New Application',
    intake_last_4_ssn: 'Last 4 of SSN',
    intake_dob: 'Date of Birth',
    intake_signature_required: 'Signature is required',
    intake_submitted: 'Form submitted successfully!',
    
    // Dashboard
    dashboard_title: 'Dashboard',
    dashboard_submissions: 'Submissions',
    dashboard_users: 'Users',
    dashboard_audit: 'Audit Log',
    dashboard_settings: 'Settings',
    dashboard_logout: 'Logout',
    
    // Footer
    footer_developer: 'Built by James Hudson @ Texas IT Nerds',
    footer_license: 'Lone Star Bonding Co. | License No. 74629',
    footer_secured: 'Secured by TITN Aegis Security',
    navigation: 'NAVIGATION',
    available_24_7: 'Available 24/7',
  },
  es: {
    // Common
    call_now: 'Llamar Ahora',
    get_directions: 'Obtener Direcciones',
    learn_more: 'Conocer Mas',
    contact_us: 'Contactenos',
    submit: 'Enviar',
    cancel: 'Cancelar',
    save: 'Guardar',
    delete: 'Eliminar',
    edit: 'Editar',
    back: 'Atras',
    next: 'Siguiente',
    loading: 'Cargando...',
    error: 'Error',
    success: 'Exito',
    
    // Navigation
    home: 'Inicio',
    about: 'Nosotros',
    services: 'Servicios',
    contact: 'Contacto',
    intake: 'Solicitud',
    dashboard: 'Panel de Control',
    faq: 'Preguntas Frecuentes',
    service_areas: 'Areas de Servicio',
    how_bail_works: 'Como Funciona',
    
    // Emergency Banner
    emergency_banner: 'SERVICIO DE EMERGENCIA DE FIANZAS 24/7',
    
    // Home Page
    home_hero_title: 'Rapido. Confidencial. Fianzas en Houston 24/7.',
    home_hero_subtitle: 'Libere a su ser querido rapidamente con Lone Star Bonding Co. Con licencia, experiencia y confianza desde 1990.',
    home_tagline: 'Fianzas en Houston 24/7 - Liberacion Rapida - Confidencial',
    over_30_years: 'MAS DE 30 ANOS DE SERVICIO',
    why_choose_us: 'POR QUE ELEGIRNOS',
    proven_authority: 'AUTORIDAD COMPROBADA',
    proven_authority_desc: 'Mas de tres decadas sirviendo a Houston con integridad, rapidez y compromiso inquebrantable.',
    serving_all_houston: 'SIRVIENDO A TODO HOUSTON',
    service_areas_desc: 'Cobertura de fianzas las 24 horas para todas las carceles y comunidades del area de Houston en el Condado de Harris y mas alla.',
    view_all_areas: 'VER TODAS LAS AREAS DE SERVICIO',
    dont_wait: 'NO ESPERE',
    dont_wait_desc: 'Alguien esta listo para ayudarle en este momento. Cada minuto cuenta.',
    
    // About Page
    about_title: 'Acerca de Lone Star Bonding Co.',
    about_steve_cruz: 'Conozca a Steve Cruz',
    about_experience: 'Mas de 30 Anos de Experiencia',
    about_license: 'Con Licencia - No. 74629',
    our_story: 'NUESTRA HISTORIA',
    our_core_values: 'NUESTROS VALORES FUNDAMENTALES',
    our_history: 'NUESTRA TRAYECTORIA',
    your_trusted_bondsman: 'SU FIADOR DE CONFIANZA EN HOUSTON',
    
    // Services Page
    services_title: 'Nuestros Servicios',
    services_bail_bonds: 'Fianzas',
    services_24_7: 'Disponibilidad 24/7',
    services_bilingual: 'Servicio Bilingue',
    bail_bond_solutions: 'SOLUCIONES DE FIANZA',
    
    // Contact Page
    contact_title: 'Contactenos',
    contact_phone: 'Telefono',
    contact_address: 'Direccion',
    contact_hours: 'Horario',
    contact_24_7: '24/7 - Abierto Todo el Dia, Todos los Dias',
    location: 'UBICACION',
    
    // FAQ
    faq_title: 'PREGUNTAS FRECUENTES SOBRE FIANZAS',
    faq_subtitle: 'Respuestas a las preguntas mas comunes sobre fianzas en Houston y el Condado de Harris.',
    still_have_questions: 'TODAVIA TIENE PREGUNTAS?',
    still_have_questions_desc: 'Llamenos. Estamos disponibles las 24 horas del dia, los 7 dias de la semana para ayudarle.',
    
    // How Bail Works
    step_by_step: 'GUIA PASO A PASO',
    how_bail_works_title: 'COMO FUNCIONAN LAS FIANZAS',
    how_bail_works_subtitle: 'Entender el proceso de fianzas no tiene que ser complicado. Aqui le explicamos exactamente como funciona de principio a fin.',
    key_facts: 'DATOS IMPORTANTES',
    ready_to_start: 'LISTO PARA COMENZAR?',
    ready_to_start_desc: 'Llamenos ahora y le guiaremos en cada paso del proceso.',
    
    // Service Areas
    service_areas_title: 'SIRVIENDO CADA VECINDARIO DE HOUSTON',
    service_areas_hero_desc: 'Desde el complejo de la Carcel del Condado de Harris en el centro hasta las comunidades mas lejanas del area metropolitana. Cobertura de fianzas las 24 horas para cada codigo postal, cada carcel, cada corte.',
    neighborhood_coverage: 'COBERTURA POR VECINDARIO',
    dont_see_area: 'SU AREA NO ESTA EN LA LISTA?',
    dont_see_area_desc: 'Cubrimos TODA el area metropolitana de Houston, el Condado de Harris, el Condado de Fort Bend y mas alla. Si su ser querido esta en la carcel en cualquier parte del sureste de Texas, llame. Le ayudaremos.',
    
    // Intake
    intake_title: 'Formularios de Solicitud de Fianza',
    intake_subtitle: 'Un cuestionario guiado paso a paso',
    intake_secure: 'Seguro - Confidencial - Guiado',
    intake_resume: 'Continuar Solicitud',
    intake_new: 'Nueva Solicitud',
    intake_last_4_ssn: 'Ultimos 4 del SSN',
    intake_dob: 'Fecha de Nacimiento',
    intake_signature_required: 'Se requiere firma',
    intake_submitted: 'Formulario enviado con exito!',
    
    // Dashboard
    dashboard_title: 'Panel de Control',
    dashboard_submissions: 'Solicitudes',
    dashboard_users: 'Usuarios',
    dashboard_audit: 'Registro de Auditoria',
    dashboard_settings: 'Configuracion',
    dashboard_logout: 'Cerrar Sesion',
    
    // Footer
    footer_developer: 'Desarrollado por James Hudson @ Texas IT Nerds',
    footer_license: 'Lone Star Bonding Co. | Licencia No. 74629',
    footer_secured: 'Protegido por TITN Aegis Security',
    navigation: 'NAVEGACION',
    available_24_7: 'Disponible las 24 horas',
  }
};

export default translations;
